import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { MapStatus } from "../../../../../../../util/enums";
import { SubTitle } from "../../SubTitle";
import { Status, SquareMenu, ContainerSquare } from "./styles";

interface PreviewStatusTitle {
  displayPreviewTitle?: boolean;
}
export const PreviewStatus = ({ displayPreviewTitle = true }: PreviewStatusTitle) => {
  const { t: translate } = useTranslation();

  return (
    <Grid item>
      {displayPreviewTitle && <SubTitle text={translate("locationPreviewStatus")} />}
      <ContainerSquare>
        <Status>
          <SquareMenu color={"#98A2B3"} /> <span>{MapStatus.INACTIVE}</span>
        </Status>
        <Status>
          <SquareMenu color={"#CCDEEE"} /> <span>{MapStatus.EMPTY}</span>
        </Status>
        <Status>
          <SquareMenu color={"#53B1FD"} /> <span>{MapStatus.LOADED}</span>
        </Status>
        <Status>
          <SquareMenu color={"#FAA7E0"} /> <span>{MapStatus.MIXED}</span>
        </Status>
        <Status>
          <SquareMenu color={"#12B76A"} /> <span>{MapStatus.SELECTED}</span>
        </Status>
      </ContainerSquare>
    </Grid>
  );
};
